<template>
  <transition name="setting">
    <div class="settingMask">
      <div class="settingWrapper">
        <div class="settingContainer">
          <div class="settingHeader">
            <h3>설정</h3>
          </div>
          <div class="settingBody">
            <slot name="menu">
              default
            </slot>
          </div>
          <div class="settingFooter">
            <button class="btSubmit button13" @click="close">닫기</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'setting',
  components: {
  },
  data() {
    return {
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
}
</script>

<style lang="scss">
.settingMask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .68);
  display: table;
  transition: opacity .3s ease;
}

.settingWrapper {
  display: table-cell;
  padding: 0 69px;
  vertical-align: middle;
}

.settingContainer {
  width: 100%;
  margin: 0px auto;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
}
.settingHeader {
  height: 51px;
  padding-top: 17px;
  color: #6134f1;
  font-size: 17px;
  font-weight: bold;
  text-align: center;
  border-bottom: 1px solid #606268;
  h3 {
    padding: 0;
    margin: 0;
    font-size: 100%;
  }
}
.settingBody {
  width: 100%;
  li {
    border-bottom: 1px solid #c9cbd5;
    &:last-child {
      border-bottom-width: 0;
    }
  }
  button {
    width: 100%;
    height: 52px;
    padding: 2px 15px 0;
    text-align: left;
  }
}
.setting-enter {
  opacity: 0;
}
.setting-leave-active {
  opacity: 0;
}
.setting-enter .settingContainer,
.setting-leave-active .settingContainer {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
@media all and (min-width: 426px) {
  .settingContainer {
    max-width: 288px;
  }
}
</style>

